import { render, staticRenderFns } from "./ProducerRegistrationModal.html?vue&type=template&id=7daa8754&scoped=true&external"
import script from "./ProducerRegistrationModal.ts?vue&type=script&lang=ts&external"
export * from "./ProducerRegistrationModal.ts?vue&type=script&lang=ts&external"
import style0 from "./ProducerRegistrationModal.css?vue&type=style&index=0&id=7daa8754&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7daa8754",
  null
  
)

export default component.exports